import React, { useState } from 'react';
import $ from "jquery";

function Appointment({ courseRestriction }) {
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [course, setCourse] = useState(courseRestriction || "NEET");
    const [city, setCity] = useState("");
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const allCourseOptions = [
        { value: "NEET", label: "NEET" },
        { value: "JEE", label: "JEE" },
        { value: "NATA", label: "NATA" },
        { value: "TMG College of Arts & Science", label: "TMG College of Arts & Science" },
        { value: "Distance Education", label: "Distance Education" },
        { value: "University of Madras", label: "University of Madras" },
        { value: "Bharathidasan University", label: "Bharathidasan University" },
        { value: "Tamil Nadu Open University", label: "Tamil Nadu Open University" },
        { value: "Data Science & AI", label: "Data Science & AI" },
        { value: "Classes (IX, X, XI, XII)", label: "Classes (IX, X, XI, XII)" },
        { value: "NRA CET", label: "NRA CET" },
        { value: "Degree/Diploma/Craft", label: "Degree/Diploma/Craft" },
        { value: "GATE", label: "GATE" },
        { value: "NET", label: "NET" },
        { value: "SLET", label: "SLET" },
        { value: "IES", label: "IES" },
        { value: "NCVT", label: "NCVT" },
        { value: "Industrial School", label: "Industrial School" },
        { value: "Engineering and Architecture Guidance Program", label: "Engineering and Architecture Guidance Program" },
        { value: "TNPSC, TRB, Police Exams & RRB", label: "TNPSC, TRB, Police Exams & RRB" }
    ];

    const validateForm = () => {
        const newErrors = {};
        let isValid = true;

        if (!name.trim()) {
            newErrors.name = "Name is required";
            isValid = false;
        }

        if (!phone.trim()) {
            newErrors.phone = "Phone number is required";
            isValid = false;
        } else if (!/^\d{10}$/.test(phone)) {
            newErrors.phone = "Phone number must be 10 digits";
            isValid = false;
        }

        if (!course.trim()) {
            newErrors.course = "Course is required";
            isValid = false;
        }

        if (!city.trim()) {
            newErrors.city = "City is required";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (validateForm()) {
            setIsLoading(true);
            const form = $(e.target);
            $.ajax({
                type: "POST",
                url: form.attr("action"),
                data: form.serialize(),
                success() {
                    setName("");
                    setPhone("");
                    setCourse(courseRestriction || "NEET");
                    setCity("");
                    setIsSubmitted(true);
                    setErrors({});
                },
                error(err) {
                    setIsSubmitted(true);
                    setIsLoading(false);
                }
            });
        }
    };

    const handlePhoneChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 10) {
            setPhone(value);
        }
    };

    if (isSubmitted) {
        return (
            <div className="counter-area pd-bottom-19">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 mt-5 mt-lg-0 text-center">
                            <div className="alert alert-success">
                                <h3>Thank You!</h3>
                                <p>Your enquiry has been submitted successfully.</p>
                                <p>We will contact you shortly.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="counter-area pd-bottom-19">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 mt-5 mt-lg-0">
                        <h2 className="title" style={{ fontSize: '20px' }}>Enquiry with us</h2>
                        
                        {errors.submit && (
                            <div className="alert alert-danger mb-4">{errors.submit}</div>
                        )}

                        <form className="contact-form-inner mt-5 mt-md-0" 
                            action="https://mieteducation.in/server/appointment-mail.php" 
                            method="post" 
                            onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="single-input-inner style-bg-border">
                                        <input 
                                            type="text" 
                                            placeholder="Name" 
                                            id="name"
                                            name="name"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)} 
                                        />
                                        {errors.name && <div className="text-danger small mt-1">{errors.name}</div>}
                                    </div>
                                </div>
                            
                                <div className="col-12">
                                    <div className="single-input-inner style-bg-border">
                                        <input 
                                            type="text" 
                                            placeholder="Phone" 
                                            id="phone"
                                            name="phone"
                                            value={phone}
                                            onChange={handlePhoneChange}
                                        />
                                        {errors.phone && <div className="text-danger small mt-1">{errors.phone}</div>}
                                    </div>
                                </div>
                                
                                <div className="col-12">
                                    <div className="single-input-inner style-bg-border">
                                        {courseRestriction ? (
                                            // Display as hidden input (for form submission) and text display
                                            <>
                                                <input
                                                    type="hidden"
                                                    id="course"
                                                    name="course"
                                                    value={courseRestriction}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={courseRestriction}
                                                    readOnly
                                                />
                                            </>
                                        ) : (
                                            // Display as dropdown when no restriction
                                            <select
                                                className="form-select"
                                                id="course"
                                                name="course"
                                                value={course}
                                                onChange={(e) => setCourse(e.target.value)}
                                                required
                                            >
                                                {allCourseOptions.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                        {errors.course && <div className="text-danger small mt-1">{errors.course}</div>}
                                    </div>
                                </div>
                                
                                <div className="col-12">
                                    <div className="single-input-inner style-bg-border">
                                        <input 
                                            type="text" 
                                            placeholder="City" 
                                            id="city"
                                            name="city"
                                            value={city}
                                            onChange={(e) => setCity(e.target.value)} 
                                        />
                                        {errors.city && <div className="text-danger small mt-1">{errors.city}</div>}
                                    </div>
                                </div>
                                
                                <div className="col-12">
                                    <button 
                                        className="btn btn-base" 
                                        type="submit"
                                        disabled={isLoading}
                                    >
                                        {isLoading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Sending...
                                            </>
                                        ) : (
                                            "Send Message"
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Appointment;